<template>
  <v-menu
    v-if="getWebchat().interaction.state !== 'started' && !fromChat"
    top
    :close-on-content-click="false"
    :offset-x="true"
    :offset-y="true"
    absolute
    :position-y="8"
    :position-x="8"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :color="invertColor(getWebchat().campaign.color)"
        dark
        v-bind="attrs"
        v-on="on"
        icon
        style="position: absolute; left: 8px; z-index: 1"
        :style="[
          { color: invertColor(getWebchat().campaign.color) },
          { top: getWebchat().isLowRes ? '32px' : '8px' },
          { zoom: `1.${getWebchat().client.accessibility.fontSize}` },
        ]"
        class="accessibility-options-button"
      >
        <v-icon> mdi-human </v-icon>
      </v-btn>
    </template>

    <v-list class="py-3">
      <v-list-item
        v-for="(item, i) in accessibilityOptions"
        :key="i"
        style="min-height: auto"
        @click="item.action"
      >
        <v-list-item-icon class="ma-0 py-2 pr-2">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t(item.label) }}</v-list-item-title>
          <v-list-item-subtitle>
            <v-stepper
              v-model="getWebchat().client.accessibility.fontSize"
              flat
              class="d-flex justify-center mx-2 pa-0 mb-2"
              style="
                gap: 3px;
                background-color: transparent;
                justify-content: flex-start !important;
              "
            >
              <v-stepper-step
                v-for="i of 3"
                :key="i"
                @click="item.action"
                class="pa-0"
                :complete="i == getWebchat().client.accessibility.fontSize"
                step=" "
                complete-icon=" "
                style="height: 5px; border-radius: 10px; background: white"
              />
            </v-stepper>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-row
    v-else-if="getWebchat().interaction.state === 'started' && fromChat"
    no-gutters
    class="pt-2 accessibility-options-dialog"
    :style="{
      'background-color': getWebchat().campaign.color,
      color: invertColor(getWebchat().campaign.color),
    }"
    :class="{ show: show }"
  >
    <v-col cols="12">
      {{ $t("accessibilityMenu") }}
      <v-btn
        elevation="0"
        fab
        icon
        depressed
        absolute
        x-small
        style="bottom: 4px; right: 4px"
        :color="invertColor(getWebchat().campaign.color)"
        @click="$emit('close')"
        ><v-icon>mdi-arrow-up</v-icon></v-btn
      >
    </v-col>
    <v-col cols="12">
      <div class="d-flex flex-column align-start">
        <v-btn
          v-for="(item, index) in accessibilityOptions"
          :key="index"
          :color="invertColor(getWebchat().campaign.color)"
          class="mx-2 pa-0"
          text
          @click="item.action"
        >
          <v-icon> {{ item.icon }} </v-icon>
          {{ $t(item.label) }}
        </v-btn>
        <v-stepper
          v-model="getWebchat().client.accessibility.fontSize"
          flat
          class="d-flex justify-center mx-2 pa-0 mb-2"
          style="gap: 3px; background-color: transparent"
        >
          <v-stepper-step
            v-for="i of 3"
            :key="i"
            class="pa-0"
            :complete="i == getWebchat().client.accessibility.fontSize"
            step=" "
            complete-icon=" "
            style="height: 5px; border-radius: 10px; background: white"
          />
        </v-stepper>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { invertColor } from "@/assets/utils";
export default {
  props: {
    show: Boolean,
    fromChat: Boolean,
  },
  name: "accessibility-options-dialog",
  data() {
    return {
      accessibilityOptions: [
        {
          name: "fontsize",
          icon: "mdi-format-size",
          label: "Font size",
          action: () => {
            this.$store.commit(
              "setAccessibilityFontSize",
              this.getWebchat().client.accessibility.fontSize >= 3
                ? 0
                : this.getWebchat().client.accessibility.fontSize + 1
            );
            window.parent.postMessage(
              {
                action: "WEBCHAT_SIZE",
                size: this.getWebchat().client.accessibility.fontSize,
              },
              "*"
            );
          },
        },
      ],
    };
  },

  methods: {
    invertColor,

    getWebchat() {
      return this.$store.state[
        this.$store.state.findIndex(
          (e) => e.configuration.campaign === this.$route.query.campaign
        )
      ];
    },

    no() {
      this.$emit("no", false);
    },

    yes() {
      this.$emit("yes", true);
    },
  },
};
</script>

<style>
.accessibility-options-dialog {
  /* position: absolute; */
  top: 0px;
  height: 75px;
  opacity: 0;
  padding-top: 10px;
  border-top: 1px solid #00000054;
  box-shadow: 0px 4px 5px -3px #00000066;
  text-align: center;
  transition: all 0.3s ease-out;
  background: linear-gradient(
    129deg,
    rgba(35, 146, 236, 0),
    rgba(0, 0, 0, 0.35)
  );
}

.accessibility-options-dialog.show {
  top: 67px;
  opacity: 1;
  z-index: 999;
}

.accessibility-options-dialog button {
  z-index: 2;
  opacity: 0.8;
}
</style>
